export const menuItems = [
  {
    name: '豚骨醤油ラーメン',
    description: '豚骨と醤油の絶妙なバランス。深いコクと旨味が凝縮された定番の一杯。',
    price: '850',
    image: 'https://static.readdy.ai/image/fe9af1ed768c21ad7118d7d5eb00ae7d/7ebb9f897bc8165675051368e0be8508.webp#tsuru-top-left'
  },
  {
    name: '豚骨醤油スペシャル',
    description: '定番の豚骨醤油に特製トッピングをプラス。チャーシュー・味玉・海苔が贅沢に乗った特別な一杯。',
    price: '1100',
    image: 'https://static.readdy.ai/image/fe9af1ed768c21ad7118d7d5eb00ae7d/7ebb9f897bc8165675051368e0be8508.webp#tsuru-top-right'
  },
  {
    name: '紅鶴ラーメン',
    description: '激辛！特製辛味噌と豚骨スープが融合。辛さの中に旨味が広がる鶴の看板メニュー。',
    price: '1100',
    image: 'https://static.readdy.ai/image/fe9af1ed768c21ad7118d7d5eb00ae7d/7ebb9f897bc8165675051368e0be8508.webp#tsuru-bottom-left'
  },
  {
    name: '豚骨醤油チャーシュー',
    description: '自家製チャーシューをたっぷりトッピング。肉好きにはたまらない贅沢な一杯。',
    price: '1200',
    image: 'https://static.readdy.ai/image/fe9af1ed768c21ad7118d7d5eb00ae7d/7ebb9f897bc8165675051368e0be8508.webp#tsuru-bottom-right'
  }
];

export const toppings = [
  { name: '味玉・キャベモヤ・メンマ・のり・ほうれん草', price: '150' },
  { name: 'チャーシュー（3枚）', price: '300' }
];

export const extras = [
  { name: 'ラーメン大盛', price: '150' },
  { name: 'ライス（国産米）', price: '100' }
];

export const drinks = [
  { name: '瓶ビール', price: '750' },
  { name: 'コカコーラ', price: '200' }
];
